import { render, staticRenderFns } from "./StatusBtn.vue?vue&type=template&id=2d7f40b8&scoped=true&"
import script from "./StatusBtn.vue?vue&type=script&lang=ts&"
export * from "./StatusBtn.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBtn.vue?vue&type=style&index=0&id=2d7f40b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f40b8",
  null
  
)

export default component.exports